module.exports = __webpack_public_path__ + "img/slide-3.fcee4d93.jpg";